package nacholab.supplies.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color

data class ColorScheme(
    val primary: Color,
    val primaryVariant: Color,
    val secondary: Color,
    val secondaryVariant: Color,
    val background: Color,

    val utilityField: Color,
    val utilityBlack: Color,
    val utilityError: Color,
    val utilityTableBorder: Color,
    val utilityBackdrop: Color,
)